const CANCELLATION_ELIGIBLE_STATES = ['CA', 'CO', 'DE', 'IL', 'NY', 'VA', 'VT'];

export default CANCELLATION_ELIGIBLE_STATES;
